import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore, gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import {
  FreeBetWinningType,
  getAmountWithCurrency,
  parseNumberByPrecision,
  toFixed,
} from '@pascal/pascal-core';

import { doBetStore, gameStore } from '../../../store';
import { globalTranslationKeys } from '../../../enums';
import { maxRangeValue } from '../../../helpers/constants';

const BetInfoSection = observer(({ t, marketType, rangeNumber, amount }) => {
  const { margin = 4 } = gameStore;
  const { limits } = gameConfigStore;
  const { activeFreeBet } = freeBetStore;

  const chance = useMemo(() => {
    return !marketType ? rangeNumber : maxRangeValue - rangeNumber;
  }, [marketType, rangeNumber]);

  const odd = useMemo(() => {
    if (!marketType) {
      return Math.trunc(((1 - +margin / 100) / (+rangeNumber / 100)) * 100) / 100;
    }
    return Math.trunc(((1 - +margin / 100) / ((100 - (+rangeNumber + 1)) / 100)) * 100) / 100;
  }, [marketType, rangeNumber, margin]);

  const payout = useMemo(() => {
    if (amount) {
      if (odd * amount > limits.maxWin) {
        return parseNumberByPrecision(limits.maxWin, 1, 2);
      }
      return parseNumberByPrecision(odd, amount, 2);
    }
    return null;
  }, [odd, amount, limits.maxWin]);

  useEffect(() => {
    // if (isDemo) {
    //   setDemoBetOdd(odd);
    // }
    doBetStore.setCurrentOdd(odd);
  }, [odd]);

  const exactPayout = useMemo(() => {
    let correctPayout = payout;

    if (limits.maxWin < payout) {
      correctPayout = limits.maxWin;
    }

    if (activeFreeBet.id && activeFreeBet.winType === FreeBetWinningType.Win) {
      correctPayout -= activeFreeBet.amount;
      correctPayout = correctPayout > 0 ? correctPayout : 0;
    }

    return correctPayout ? toFixed(correctPayout) : 0;
  }, [payout, limits, activeFreeBet]);

  return (
    <div className='monti-bet-info'>
      <div className='monti-bet-info-column'>
        <p className='monti-bet-info-heading'>{t(globalTranslationKeys.Odd)}:</p>
        <p className='monti-bet-info-value'>x{odd}</p>
      </div>
      <div className='monti-bet-info-column'>
        <p className='monti-bet-info-heading'>{t(globalTranslationKeys.Payout)}:</p>
        <p className='monti-bet-info-value'>
          {getAmountWithCurrency({
            amount: exactPayout || '',
          })}
        </p>
      </div>
      <div className='monti-bet-info-column'>
        <p className='monti-bet-info-heading'>{t(globalTranslationKeys.Chance)}:</p>
        <p className='monti-bet-info-value'>{chance} %</p>
      </div>
    </div>
  );
});

export default BetInfoSection;
